import { render, staticRenderFns } from "./ApprovalDocumentForm.vue?vue&type=template&id=c4d19514&scoped=true"
import script from "./ApprovalDocumentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalDocumentForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApprovalDocumentForm.vue?vue&type=style&index=0&id=c4d19514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d19514",
  null
  
)

export default component.exports